export var MODE = {
  FULL: 'full',
  MINI: 'mini'
};